module.exports = __webpack_public_path__ + "img/2.79028661.png";